const getErrorObject = (error) => {
  const missingSalesforceRecord = error?.body?.error?.detail?.includes('No Salesforce contact info found')
  const salesforceErrorObject = {
    message: 'No Salesforce contact info found',
    hasRecord: false,
    error: { ...error }
  }
  const errorObject = missingSalesforceRecord ? salesforceErrorObject : { error: { ...error } }
  return errorObject
}

export const useFetchCaseCounts = (maApiHost, authenticatedFetch, useQuery, isOpen) => {
  const pathName = '/eod/cases?only_counts=true'
  const url = new URL(pathName, maApiHost)
  const query = useQuery([url], async () => {
    try {
      const response = await authenticatedFetch(url)
      if (response.ok) {
        return response.json()
      } else {
        throw new Error(response)
      }
    } catch (error) {
      const errorObject = getErrorObject(error)
      console.error(`Error fetching ${pathName}`, errorObject)
      return errorObject
    }
  }, {
    enabled: isOpen === 'expanded',
  })
  return query
}

export const useFetchEodCase = (useQuery, id, maApiHost, authenticatedFetch) => {
  const pathName = `/eod/cases/${id}`
  const url = new URL(pathName, maApiHost)
  const data = useQuery([url], async () => {
    try {
      const response = await authenticatedFetch(url)
      if (response.ok) {
        return response.json()
      } else {
        throw new Error(response)
      }
    } catch (error) {
      console.error(error)
      throw new Error(error)
    }
  }, {
    enabled: !!id,
  })
  return data
}

export const useFetchAllEodCases = (useQuery, maApiHost, authenticatedFetch) => {
  const pathName = '/eod/cases'
  const url = new URL(pathName, maApiHost)
  const query = useQuery([url], async () => {
    try {
      const response = await authenticatedFetch(url)
      if (response.ok) {
        return response.json()
      } else {
        throw new Error(response)
      }
    } catch (error) {
      const errorObject = getErrorObject(error)
      console.error(errorObject)
      return errorObject
    }
  })
  return query
}
